var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23804 12.5475L12.619 5.1665",
    stroke: "black",
    strokeWidth: 1.10714,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    color: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23804 5.1665H12.619V12.5475",
    stroke: "black",
    strokeWidth: 1.10714,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    color: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBlack);
export default __webpack_public_path__ + "static/media/arrow_up_black.b79cad6dbb340d41bda4bedb35962dbe.svg";
export { ForwardRef as ReactComponent };